import React, { useState } from "react";
import { useSelector } from "react-redux";
import useMediaQuery from "@mui/material/useMediaQuery";
import EcosystemPanel from "../components/EcosystemPanel";
import CommonTable from "./CommonTable";
import Loading from "./Loading";

const DynamicTab = () => {
  const { data, loading, error } = useSelector((state) => state.case);
  const isSmallScreen = useMediaQuery("(max-width:768px)");
  const [ecosystemOpen, setEcosystemOpen] = useState(!isSmallScreen);

  return (
    <div style={{ display: "flex", flex: 1, minHeight: 0, overflow: "hidden", position: "relative" }}>
      <div style={{ flex: 1, overflowY: "auto" }}>
        {loading ? (
          <Loading />
        ) : (
          <CommonTable rows={data} />
        )}
      </div>
      <EcosystemPanel open={ecosystemOpen} onToggle={() => setEcosystemOpen((prev) => !prev)} />
    </div>
  );
};

export default DynamicTab;
